import { render, staticRenderFns } from "./OtherUserModal.vue?vue&type=template&id=082154ec&scoped=true&"
import script from "./OtherUserModal.vue?vue&type=script&lang=js&"
export * from "./OtherUserModal.vue?vue&type=script&lang=js&"
import style0 from "./OtherUserModal.vue?vue&type=style&index=0&id=082154ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082154ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
